import React, { Component, PropTypes } from 'react';
import { findDOMNode } from 'react-dom';
import { IconButton } from 'material-ui';
import Icon from '../../tc-ui/icon';
import { prop } from 'ramda';

class Name extends Component {

  constructor(props) {
    super(props);
    this.state = {
      showFullTitle: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      showFullTitle: nextProps.containerWidth && findDOMNode(this.refs.nameNode) && (findDOMNode(this.refs.nameNode).offsetWidth >= nextProps.containerWidth * 0.83),
    });
  }

  getEditNameIcon = () => {
    const iconContainerStyle = {
      display: 'inline-block',
      marginLeft: '8px',
      fontSize: '16px',
      clear: 'both',
      overflow: 'hidden',
    };

    return (
      <div style={iconContainerStyle} className="profile-edit-icon-container" onClick={this._editName}>
        <Icon className="tc-icon-mode_edit profile-edit-icon"/>
        EDIT
      </div>
    );
  };

  _editName = () => {
    const { editField, routeName, profileToShow } = this.props;
    const isSupplier = this.props.profile.type === 'Supplier';
    const isAccom = this.props.profile.productType === 'accommodation';
    editField(`${routeName}Name`,
      {
        specifiedRoute: routeName,
        isRequired: true,
        value: profileToShow[`${routeName}Name`],
        type: `${routeName}Name`,
        warningNode: !isSupplier ? null : (
          <div>
            <i>Please note: If you have existing contracts using this {isAccom && routeName === 'location' ? 'property' : routeName}, those <b>existing contracts will not be updated</b> with the new name.  Please contact your partners to inform them of this change.</i>
          </div>
        ),
      });
  };

  _showTooltip = () => {
    this.setState({ tooltipShown: true });
  };

  _hideTooltip = () => {
    this.setState({ tooltipShown: false });
  };

  _handleMouseLeave = () => {
    this._hideTooltip();
  };

  _handleMouseEnter = () => {
    this._showTooltip();
  };

  render() {
    const { profileToShow, isEditable, routeName } = this.props;

    const profileNameField = routeName === 'profile' ? 'companyName' : `${routeName}Name`;

    const containerStyle = {
      display: 'inline-block',
      position: 'relative',
      fontSize: 'calc(20px + 0.5vw)',
      color: profileToShow.coverImageUrl ? 'white' : 'rgba(0, 0, 0, 0.87)',
      maxWidth: '65%',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      lineHeight: '43px',
    };

    if (this.state.showFullTitle) {
      containerStyle.position = 'relative';
      containerStyle.height = '43px';
    }

    return (
      <div style={this.state.showFullTitle ? { height: '32px', maxHeight: '32px' } : {}}>
        <div
          style={containerStyle}
          onMouseEnter={this._handleMouseEnter}
          onMouseLeave={this._handleMouseLeave}
        >
          {<span ref="nameNode">{profileToShow[profileNameField]}</span>}
          {
            prop('quickResponder', profileToShow) ?
              <span style={{ overflow: 'visible' }}>
                <IconButton
                  iconClassName="tc-icon-update"
                  iconStyle={{ fontSize: '24px', color: '#7F00FF', backgroundColor: '#ffffff', borderRadius: '50%', padding: '2px', opacity: '0.8' }}
                  tooltip="Quick Responder"
                  tooltipPosition="top-right"
                />
              </span> : <span/>
          }
        </div>
        {routeName !== 'profile' && isEditable ? this.getEditNameIcon() : null}
      </div>
    );
  }
}


Name.propTypes = {
  editField: PropTypes.func,
  routeName: PropTypes.string,
  profileToShow: PropTypes.object,
  isEditable: PropTypes.bool,
};

export default Name;



// WEBPACK FOOTER //
// ./src/app/components/profile/profile-top-bar/name-node.jsx